export const GENERAL_SETTINGS = {
  id: 'gs-01',
  organization_name: 'Everest Demo',
  organization_email: 'support@everest.io',
  organization_phone: '+62 21 5555 0100',
  default_language: 'en',
  default_timezone: 'Asia/Jakarta',
  session_timeout: 30,
  verification_threshold: 85,
  logout_timer: null,
  logo_url: null,
  brand_color: '#42307D',
  consent_validity_days: 365,
  default_currency: 'IDR',
  allow_self_signup: false,
  notification_email_enabled: true,
  notification_whatsapp_enabled: true,
  updated_at: '2026-04-30T08:12:00Z',
}

export const EMPLOYMENT_LEVELS = [
  {
    id: 'lvl-01',
    name: 'C-Level / Executive',
    code: 'EXEC',
    sort_order: 1,
    position_count: 5,
    salary_from: 80_000_000,
    salary_to: 200_000_000,
    currency: 'IDR',
    consent_expiry: '2027-12-31',
    repeat_every: 'annual',
    is_active: true,
  },
  {
    id: 'lvl-02',
    name: 'Director',
    code: 'DIR',
    sort_order: 2,
    position_count: 7,
    salary_from: 50_000_000,
    salary_to: 90_000_000,
    currency: 'IDR',
    consent_expiry: '2027-09-30',
    repeat_every: 'annual',
    is_active: true,
  },
  {
    id: 'lvl-03',
    name: 'Senior Manager',
    code: 'SRMGR',
    sort_order: 3,
    position_count: 9,
    salary_from: 35_000_000,
    salary_to: 60_000_000,
    currency: 'IDR',
    consent_expiry: '2027-06-30',
    repeat_every: 'semiannual',
    is_active: true,
  },
  {
    id: 'lvl-04',
    name: 'Manager',
    code: 'MGR',
    sort_order: 4,
    position_count: 12,
    salary_from: 22_000_000,
    salary_to: 38_000_000,
    currency: 'IDR',
    consent_expiry: '2027-06-30',
    repeat_every: 'semiannual',
    is_active: true,
  },
  {
    id: 'lvl-05',
    name: 'Senior Specialist',
    code: 'SRSPEC',
    sort_order: 5,
    position_count: 14,
    salary_from: 15_000_000,
    salary_to: 24_000_000,
    currency: 'IDR',
    consent_expiry: '2027-03-31',
    repeat_every: 'quarterly',
    is_active: true,
  },
  {
    id: 'lvl-06',
    name: 'Specialist',
    code: 'SPEC',
    sort_order: 6,
    position_count: 18,
    salary_from: 9_000_000,
    salary_to: 16_000_000,
    currency: 'IDR',
    consent_expiry: '2027-03-31',
    repeat_every: 'quarterly',
    is_active: true,
  },
  {
    id: 'lvl-07',
    name: 'Officer / Analyst',
    code: 'OFF',
    sort_order: 7,
    position_count: 22,
    salary_from: 6_000_000,
    salary_to: 10_000_000,
    currency: 'IDR',
    consent_expiry: '2027-01-31',
    repeat_every: 'bi-monthly',
    is_active: true,
  },
  {
    id: 'lvl-08',
    name: 'Staff / Junior',
    code: 'STAFF',
    sort_order: 8,
    position_count: 24,
    salary_from: 4_500_000,
    salary_to: 7_000_000,
    currency: 'IDR',
    consent_expiry: '2026-12-31',
    repeat_every: 'monthly',
    is_active: true,
  },
]

export const EMPLOYMENT_POSITIONS = [
  { id: 'pos-01', name: 'Chief Executive Officer', level_id: 'lvl-01', level_name: 'C-Level / Executive' },
  { id: 'pos-02', name: 'Chief Financial Officer', level_id: 'lvl-01', level_name: 'C-Level / Executive' },
  { id: 'pos-03', name: 'Chief Operating Officer', level_id: 'lvl-01', level_name: 'C-Level / Executive' },
  { id: 'pos-04', name: 'Chief Human Resources Officer', level_id: 'lvl-01', level_name: 'C-Level / Executive' },
  { id: 'pos-05', name: 'Director of Finance', level_id: 'lvl-02', level_name: 'Director' },
  { id: 'pos-06', name: 'Director of Operations', level_id: 'lvl-02', level_name: 'Director' },
  { id: 'pos-07', name: 'Director of People', level_id: 'lvl-02', level_name: 'Director' },
  { id: 'pos-08', name: 'Senior Finance Manager', level_id: 'lvl-03', level_name: 'Senior Manager' },
  { id: 'pos-09', name: 'Senior HR Manager', level_id: 'lvl-03', level_name: 'Senior Manager' },
  { id: 'pos-10', name: 'Operations Manager', level_id: 'lvl-04', level_name: 'Manager' },
  { id: 'pos-11', name: 'HR Business Partner', level_id: 'lvl-04', level_name: 'Manager' },
  { id: 'pos-12', name: 'Finance Manager', level_id: 'lvl-04', level_name: 'Manager' },
  { id: 'pos-13', name: 'Senior Recruiter', level_id: 'lvl-05', level_name: 'Senior Specialist' },
  { id: 'pos-14', name: 'Senior Accountant', level_id: 'lvl-05', level_name: 'Senior Specialist' },
  { id: 'pos-15', name: 'Senior Software Engineer', level_id: 'lvl-05', level_name: 'Senior Specialist' },
  { id: 'pos-16', name: 'Recruitment Specialist', level_id: 'lvl-06', level_name: 'Specialist' },
  { id: 'pos-17', name: 'Compensation Specialist', level_id: 'lvl-06', level_name: 'Specialist' },
  { id: 'pos-18', name: 'HR Operations Specialist', level_id: 'lvl-06', level_name: 'Specialist' },
  { id: 'pos-19', name: 'Finance Analyst', level_id: 'lvl-07', level_name: 'Officer / Analyst' },
  { id: 'pos-20', name: 'HR Analyst', level_id: 'lvl-07', level_name: 'Officer / Analyst' },
  { id: 'pos-21', name: 'Operations Analyst', level_id: 'lvl-07', level_name: 'Officer / Analyst' },
  { id: 'pos-22', name: 'HR Officer', level_id: 'lvl-08', level_name: 'Staff / Junior' },
  { id: 'pos-23', name: 'Finance Officer', level_id: 'lvl-08', level_name: 'Staff / Junior' },
  { id: 'pos-24', name: 'Recruitment Officer', level_id: 'lvl-08', level_name: 'Staff / Junior' },
  { id: 'pos-25', name: 'Junior Software Engineer', level_id: 'lvl-08', level_name: 'Staff / Junior' },
]

export const CONSENT_TEMPLATES = [
  {
    id: 'consent-01',
    code: 'BACKGROUND_CHECK_CONSENT',
    name: 'Background Check Consent',
    description: 'Consent for credit history & background verification check',
    locale: 'id',
    body_html: `<h3>Surat Pernyataan Persetujuan Pemeriksaan Latar Belakang</h3>
<p>Yang bertanda tangan di bawah ini menyatakan bersedia memberikan persetujuan kepada {COMPANY_NAME} untuk melakukan pemeriksaan latar belakang termasuk namun tidak terbatas pada:</p>
<ul>
  <li>Verifikasi identitas dan dokumen kependudukan</li>
  <li>Pemeriksaan riwayat kredit melalui Sistem Layanan Informasi Keuangan (SLIK) OJK</li>
  <li>Verifikasi data pekerjaan dan pendidikan</li>
</ul>
<p>Persetujuan ini berlaku selama proses rekrutmen dan/atau selama hubungan kerja dengan {COMPANY_NAME}.</p>`,
    updated_at: '2026-04-08T05:30:00Z',
  },
  {
    id: 'consent-02',
    code: 'CREDIT_REPORT_CONSENT',
    name: 'Credit Report Consent (CLIK)',
    description: 'Consent for CLIK credit report enquiry',
    locale: 'id',
    body_html: `<h3>Persetujuan Pengambilan Laporan Kredit (CLIK)</h3>
<p>Saya menyetujui {COMPANY_NAME} mengambil laporan kredit saya dari Lembaga Pengelola Informasi Perkreditan ("CLIK") sesuai dengan ketentuan POJK No. 64/POJK.03/2020.</p>`,
    updated_at: '2026-03-22T07:10:00Z',
  },
  {
    id: 'consent-03',
    code: 'DATA_PROCESSING_CONSENT',
    name: 'Data Processing Consent (UU PDP)',
    description: 'Personal Data Protection Law consent',
    locale: 'id',
    body_html: `<h3>Persetujuan Pemrosesan Data Pribadi</h3>
<p>Sesuai dengan Undang-Undang No. 27 Tahun 2022 tentang Pelindungan Data Pribadi, saya memberikan persetujuan kepada {COMPANY_NAME} untuk memproses data pribadi saya.</p>`,
    updated_at: '2026-02-14T09:55:00Z',
  },
]
